import { Component, ViewChild } from '@angular/core';
import { Nav, NavController, Platform, MenuController, AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { HttpClient } from '../../services/HttpClient';

import { ProfilePage } from './profile/profile';

import { SlidesPage } from './slides/slides';

import { UsersPage } from './users/users';

import { ProjectsPage } from './projects/projects';

import { PublicationsPage } from './publications/publications';

import { GroupsPage } from './groups/groups';

import { NewsPage } from './news/news';

import { OffersPage } from './offers/offers';

import { TrainingsPage } from './trainings/trainings';

import { FilesPage } from './files/files';

import { LoginPage } from '../login/login';
import { SeminarsPage } from './seminars/seminars';
import { ResearchLinesPage } from './researchLines/researchLines';

@Component({
  templateUrl: 'dashboard.html',
  selector : 'page-dashboard',
  providers : [HttpClient]
})
export class DashboardPage {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  isclickPage : boolean = true;

  pages: Array<{title: string,icon: string, component: any}>;

  httpClient : HttpClient;
  baseUrl;

  constructor(
    private alertController : AlertController,
    platform: Platform,
    public storage : Storage,
    public navCtrl : NavController, 
    public menuCtrl : MenuController, 
    httpClient : HttpClient) {
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
    this.pages = [];
    let user;
    this.httpClient.get('/users/me',(error,data)=>{
      user = data.json();

      this.pages.push({ title: 'Perfil',icon : 'ios-person-outline', component: ProfilePage });

      if(user.role == 1){
        this.pages.push({ title: 'Slide', icon : 'ios-albums-outline', component: SlidesPage });
        this.pages.push({ title: 'Usuarios', icon : 'ios-people-outline', component: UsersPage });
        this.pages.push({ title: 'Departamentos',icon : 'ios-cafe-outline', component: ResearchLinesPage });
        this.pages.push({ title: 'Grupos',icon : 'ios-cafe-outline', component: GroupsPage });
      }

      //Pestaña usuarios para el rol Administrador científico
      if(user.role == 5) {
        this.pages.push({ title: 'Proyectos',icon : 'ios-briefcase-outline', component: ProjectsPage });
        this.pages.push({ title: 'Publicaciones',icon : 'ios-book-outline', component: PublicationsPage });
        this.pages.push({ title: 'Usuarios', icon : 'ios-people-outline', component: UsersPage });
      }

      if(user.role == 1 || user.role == 2){
        this.pages.push({ title: 'Proyectos',icon : 'ios-briefcase-outline', component: ProjectsPage });
      }

      if(user.role == 1 || user.role == 2 || user.role == 4){
        this.pages.push({ title: 'Publicaciones',icon : 'ios-book-outline', component: PublicationsPage });
      }

      if(user.role == 1 || user.role == 3){
        this.pages.push({ title: 'Noticias',icon : 'ios-paper-outline', component: NewsPage });
        this.pages.push({ title: 'Ofertas de trabajo',icon : 'ios-filing-outline', component: OffersPage });
        this.pages.push({ title: 'Formación',icon : 'ios-brush-outline', component: TrainingsPage });
        this.pages.push({ title: 'Seminarios',icon : 'ios-calendar-outline', component: SeminarsPage });
      }

      this.pages.push({ title: 'Archivos',icon : 'ios-attach-outline', component: FilesPage });

      this.rootPage = ProfilePage;
      
    });
  }

  openPage(page) {
    if(document.title.includes('Perfil') || this.isAlertPage(document.title)){
      this.alertController.create({
        title: '¡Atención!',
        message : '¿Seguro que deseas salir? Si has añadido información y no has guardado se perderán los datos',
        buttons : [{
          role : 'cancel',
          text : 'Permanecer aquí'
        },{
          text : 'Salir',
          handler : ()=> {
            this.nav.setRoot(page.component);
          }
        }]
      }).present();
    }else{
      this.nav.setRoot(page.component);
    }
  }

  private isAlertPage(namePage){
    let alertPages = ['Proyecto','Crear proyecto','Publicación','Crear publicación','Noticia','Crear noticia'];
    let result = false;
    for(var i = 0; i<alertPages.length && !result ;i++){
      if(namePage == alertPages[i]){
        result = true;
      }
    }
    return result;
  }

  logout(){
    this.storage.ready().then(()=>{
      this.storage.clear().then(()=>{
        this.navCtrl.setRoot(LoginPage);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts